import React, { useEffect, useState } from 'react';
import { IHeaderParams } from 'ag-grid-community';

import AgGridHeaderCheckbox from '@/components/common/TableGrid/CustomComponents/AgGridCheckbox/BaseHeaderCheckbox';

type IsSelcetedCheckboxState = boolean | null;

interface AgGridHeaderCheckboxProps extends IHeaderParams { }

export default function HeaderCheckbox(params: AgGridHeaderCheckboxProps) {
  const { api } = params;
  const [isSelectedState, setIsSelectedState] = useState<IsSelcetedCheckboxState>(false);

  const onChange = () => {
    api.forEachNodeAfterFilterAndSort((node) => {
      if (isSelectedState === null) {
        node.setSelected(true);
      }
      else {
        node.setSelected(!isSelectedState);
      }
    });
  };

  const selectionChanged = () => {
    let selectedRowsCount = 0;
    let visibleRowsCount = 0;

    api.forEachNodeAfterFilterAndSort((node) => {
      visibleRowsCount++;

      if (node.isSelected()) {
        selectedRowsCount++;
      }
    });

    setIsSelectedState(() => {
      if (visibleRowsCount === 0 || selectedRowsCount === 0) {
        return false;
      }

      if (selectedRowsCount > 0 && selectedRowsCount < visibleRowsCount) {
        return null;
      }

      return true;
    });
  };

  useEffect(() => {
    api.addEventListener('selectionChanged', selectionChanged);

    return () => {
      api.removeEventListener('selectionChanged', selectionChanged);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AgGridHeaderCheckbox
      {...params}
      id="custom-grid-row-all"
      checked={isSelectedState}
      onChange={onChange}
    />
  );
}
